import { ReactElement } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'

import { ErrorMessage } from 'components/v2/ErrorMessage'
import { InputNumber } from 'components/InputNumber'
import { Select } from 'components/v2/Select'
import { ISelectFrequencyProps } from 'features/Services/components/NewServicesV2/components/SelectFrequency/types'
import { GTRouteServiceScheduleFrequencyUnit } from 'gql/types.generated'

const Wrapper = styled.div`
  display: flex;
  gap: 8px;

  > * {
    flex: 1;
  }
`

const InputNumberWrapper = styled.div`
  min-width: 40px;
  max-width: 40px;
`

const messages = defineMessages({
  [GTRouteServiceScheduleFrequencyUnit.Day]: {
    id: 'services.form.selectFrequency.day',
    defaultMessage: 'Day'
  },
  [GTRouteServiceScheduleFrequencyUnit.Week]: {
    id: 'services.form.selectFrequency.week',
    defaultMessage: 'Week'
  }
})
const OPTIONS = [GTRouteServiceScheduleFrequencyUnit.Day, GTRouteServiceScheduleFrequencyUnit.Week]

export const SelectFrequency = ({
  id,
  frequency,
  onChange,
  onBlur,
  disabled,
  touched,
  error
}: ISelectFrequencyProps): ReactElement => {
  const intl = useIntl()

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    onChange({
      unit: event.target.value as GTRouteServiceScheduleFrequencyUnit,
      value: frequency.value
    })
  }

  return (
    <>
      <Wrapper>
        <InputNumberWrapper>
          <InputNumber
            id={`${id}.value`}
            value={frequency.value ?? ''}
            onChange={(value: string): void => {
              onChange({ unit: frequency.unit, value: parseInt(value) })
            }}
            onBlur={onBlur}
            disabled={disabled}
            small
          />
        </InputNumberWrapper>
        <Select id={`${id}.unit`} value={frequency.unit} onChange={handleSelectChange} disabled={disabled} small>
          {OPTIONS.map((option) => (
            <option key={option} value={option} disabled={disabled}>
              {intl.formatMessage(messages[option])}
            </option>
          ))}
        </Select>
      </Wrapper>
      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  )
}
